import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useRealtimeEvent, type UserEvent } from '@/features/realtime/RealtimeProvider';

import { redFlagsKeys } from './useRedFlags';

/**
 * App-root listener: a `red-flag.changed` event invalidates the red-flags root
 * (`['red-flags']`), covering the open-flag-count badge and any open-flags list.
 * Delivered to chief psychologists at the flag's location; `openCount` on the
 * payload is unreliable — refetch the count.
 */
export function useRedFlagChangedListener(): void {
  const queryClient = useQueryClient();
  const handler = useCallback(
    (_event: Extract<UserEvent, { type: 'red-flag.changed' }>) => {
      void queryClient.invalidateQueries({ queryKey: redFlagsKeys.all() });
    },
    [queryClient],
  );
  useRealtimeEvent('red-flag.changed', handler);
}
